import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import './App.css';
import './styles/GlobalFontSizes.css';
import AppRoutes from "./routes/AppRoutes";
import ToastProvider from "./common_components/Toast/ToastProvider";
import { useLocation, useNavigate } from 'react-router-dom';
import { abortAllApiCalls } from './helper/axios';
import { initializeNavigation } from './helper/navigationService';
import { HoverOverlayProvider } from './common_components/hoverOverlay/HoverOverlayProvider';
import GlobalHoverOverlay from './common_components/hoverOverlay/GlobalHoverOverlay';
import { ProjectOptionsProvider } from './context/ProjectOptionsContext';
function App() {
    const location = useLocation();
    const navigate = useNavigate();
    const prevPathRef = useRef(location.pathname + location.search);
    // Initialize navigation service once
    useEffect(() => {
        initializeNavigation(navigate);
    }, [navigate]);
    useEffect(() => {
        const currentPath = location.pathname + location.search;
        return () => {
            if (prevPathRef.current !== currentPath) {
                abortAllApiCalls();
            }
            prevPathRef.current = currentPath;
        };
    }, [location.pathname, location.search]);
    return (_jsx(_Fragment, { children: _jsx(ProjectOptionsProvider, { children: _jsxs(HoverOverlayProvider, { children: [_jsx(ToastProvider, { children: _jsx(AppRoutes, {}) }), _jsx(GlobalHoverOverlay, {})] }) }) }));
}
export default App;
